var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25 643 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32,654.96h-2.62c-.28,0-.51-.25-.51-.56,0-.2.08-.37.18-.45l10.41-10.35c.2-.2.51-.2.71,0l10.53,10.35c.2.23.23.59.05.82-.1.14-.25.2-.41.2h-2.62v9.93c0,.31-.23.56-.51.56h-4.43c-.28,0-.53-.25-.53-.56v-6.38h-5.01v6.38c0,.31-.23.56-.51.56h-4.2c-.31,0-.53-.25-.53-.56v-9.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNav);
export default __webpack_public_path__ + "static/media/home-nav.e5aeb00eef7fd5fe56f1d1d2b04c0a5f.svg";
export { ForwardRef as ReactComponent };